import POKEBALLIMG from "../../assets/pokeball.jpg";
import PINBALLIMG from "../../assets/pinball.jpg";

export const Projects = [
  {
    id: 0,
    title: "Pokedex",
    github: "https://github.com/seanrmcgovern/Pokedex",
    demo: "https://www.youtube.com/watch?v=j3-sw69TbPo",
    image: POKEBALLIMG,
  },
  {
    id: 1,
    title: "Pinball Tracker",
    github: "https://github.com/seanrmcgovern/Pinball-Tracker",
    demo: "https://www.youtube.com/watch?v=A7WYX6Qy4VA",
    image: PINBALLIMG,
  },
];

export default Projects;
